var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { errors } from '@feathersjs/client';
import * as Raven from 'raven-js';
import { EventRole } from 'src/imports/server-main/authorization.enum';
import { feathersServices } from 'src/feathers';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import ButtonAction from 'src/pages/components/utilities/ButtonAction';
var selfStyles = require('./styles.scss');
var ListUserEventRoleItemSelect = (function (_super) {
    __extends(ListUserEventRoleItemSelect, _super);
    function ListUserEventRoleItemSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
            role: String(props.userEventRole.role),
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.handleSubmitForm = _this.handleSubmitForm.bind(_this);
        return _this;
    }
    ListUserEventRoleItemSelect.prototype.onChange = function (newValue) {
        this.setState({ role: newValue });
    };
    ListUserEventRoleItemSelect.prototype.handleSubmitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isFetching: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.props.handlePatchUserEventRole({
                                id: this.props.userEventRole.id,
                                role: Number(this.state.role),
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.action.type !== feathersServices.userEventRoles.types.SERVICES_USEREVENTROLES_PATCH_FULFILLED) {
                            throw new errors.GeneralError('Role was not saved');
                        }
                        this.setState({ isFetching: false });
                        message.success('Role was successfully saved!');
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({ isFetching: false });
                        Raven.captureException(err_1);
                        if (err_1.message) {
                            message.error(err_1.message);
                        }
                        else {
                            message.error('There are several errors in your data. Please correct them');
                        }
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    ListUserEventRoleItemSelect.prototype.render = function () {
        return (React.createElement("div", { className: selfStyles.itemSelectWrapper },
            React.createElement(Select, { value: this.state.role, onChange: this.onChange, className: selfStyles.select, disabled: this.props.user.id === this.props.userEventRole.userId },
                React.createElement(Select.Option, { value: String(EventRole.Organizer) }, "Organizer"),
                React.createElement(Select.Option, { value: String(EventRole.Judge) }, "Judge (Active)"),
                React.createElement(Select.Option, { value: String(EventRole.JudgePending), disabled: true }, "Judge (Request!)"),
                React.createElement(Select.Option, { value: String(EventRole.JudgeInactive) }, "Judge (Inactive)"),
                React.createElement(Select.Option, { value: String(EventRole.Pending), disabled: true }, "Role Request!"),
                React.createElement(Select.Option, { value: String(EventRole.Blocked) }, "No role")),
            this.state.role !== String(this.props.userEventRole.role) &&
                (React.createElement(ButtonAction, { width: '40px', className: selfStyles.button },
                    React.createElement("button", { onClick: this.handleSubmitForm },
                        React.createElement(Icon, { type: 'check-circle', className: selfStyles.buttonIcon }))))));
    };
    return ListUserEventRoleItemSelect;
}(React.Component));
export default ListUserEventRoleItemSelect;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListUserEventRolePage/ListUserEventRoleItemSelect.tsx
// module id = 1080
// module chunks = 0